import { render, staticRenderFns } from "./changePayPwd.vue?vue&type=template&id=79c52127"
import script from "./changePayPwd.vue?vue&type=script&lang=js"
export * from "./changePayPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports